import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/half-day-slots")({
  component: () => <Outlet />,
});
